import { render, staticRenderFns } from "./SectionPlaceholder.vue?vue&type=template&id=730e4109&"
import script from "./SectionPlaceholder.vue?vue&type=script&lang=js&"
export * from "./SectionPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./SectionPlaceholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports